import { useFormContext } from 'react-hook-form';
import { CourierInvoiceDisputeDto, InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import { ContentContact } from './ContentContact';
import { DisputeSummary } from './Summary';
import { IDisputeFormValues, DisputeStep } from './types';

import { FormResolution } from './FormResolution';
import { CourierFormResolution } from './CourierFormResolution';
import { CourierDisputeSummary } from './CourierDisputeSummary';

export interface IMainContentProps {
  invoiceSummary: InvoiceSummaryDto;
  activeStep: DisputeStep;
}

export const MainContent: React.FC<IMainContentProps> = (props) => {
  const { activeStep, invoiceSummary } = props;
  const { watch } = useFormContext();
  const values = watch();

  return (
    <div className='pt-16 xl:pt-20 px-16 xl:px-24 pb-18 xl:pb-24'>
      {activeStep === DisputeStep.Step1_ContactServiceProvider && <ContentContact billedEntityId={invoiceSummary?.billedPartyId} />}
      {activeStep === DisputeStep.Step2_Resolution && <FormResolution invoiceSummary={invoiceSummary} />}
      {activeStep === DisputeStep.Step3_Summary && <DisputeSummary invoiceSummary={invoiceSummary} values={values as IDisputeFormValues} />}
    </div>
  );
};

export interface IMainContentCourierProps {
  activeStep: DisputeStep;
  courierDisputeDetail: CourierInvoiceDisputeDto;
  invoiceSummary: InvoiceSummaryDto;
}

// TODO: integrate API for courier invoice here
export const MainContentCourier: React.FC<IMainContentCourierProps> = (props) => {
  const { activeStep, courierDisputeDetail: courierDetail, invoiceSummary } = props;
  const { watch } = useFormContext();
  const values = watch();

  return (
    <div className='pt-16 xl:pt-20 px-16 xl:px-24 pb-18 xl:pb-24'>
      {activeStep === DisputeStep.Step1_ContactServiceProvider && <ContentContact billedEntityId={invoiceSummary?.billedPartyId} />}
      {activeStep === DisputeStep.Step2_Resolution && <CourierFormResolution courierInvoiceDisputeDto={courierDetail} />}
      {activeStep === DisputeStep.Step3_Summary && <CourierDisputeSummary courierDetail={courierDetail} values={values as IDisputeFormValues} />}
    </div>
  );
};
